import React from 'react';


const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
      <path d="M2.91406 4.25H4.33073H15.6641" stroke="#777777" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.2477 4.25001V14.1667C14.2477 14.5424 14.0985 14.9027 13.8328 15.1684C13.5671 15.4341 13.2068 15.5833 12.8311 15.5833H5.74772C5.372 15.5833 5.01166 15.4341 4.74599 15.1684C4.48031 14.9027 4.33105 14.5424 4.33105 14.1667V4.25001M6.45605 4.25001V2.83334C6.45605 2.45762 6.60531 2.09728 6.87099 1.8316C7.13666 1.56593 7.497 1.41667 7.87272 1.41667H10.7061C11.0818 1.41667 11.4421 1.56593 11.7078 1.8316C11.9735 2.09728 12.1227 2.45762 12.1227 2.83334V4.25001" stroke="#777777" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.87207 7.79167V12.0417" stroke="#777777" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.7061 7.79167V12.0417" stroke="#777777" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default EditIcon;
